import React, { useState } from "react";
import { SkeletonCard } from "../../context/Customfunction";
import { formatTime } from "../../utils/common";

function EventLogsTable({ loading, datalogs }) {
  const [zoomImage, setZoomImage] = useState(null);

  if (!loading && (!datalogs || datalogs.length === 0)) {
    return <p className="px-3">{/* No logs available */}</p>;
  }

  const excludedKeys = [
    "created_at",
    "camera_id",
    "camera_name",
    "_id",
    "status",
    "camera_location",
  ];

  const columns =
    datalogs.length > 0
      ? Object.keys(datalogs[0]).filter((key) => !excludedKeys.includes(key))
      : [];

  // Format header names (snake_case → Title Case)
  const formatHeader = (text) =>
    text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      <div className="px-3 my-3 cstHeighRight">
        {loading ? (
          Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
        ) : (
          <div className="table-responsive" style={{ maxHeight: "calc(100vh - 200px)" }}>
            <table className="table table-hover align-middle mb-0">
              <thead
                className="sticky-top"
                style={{
                  top: 0,
                  zIndex: 2,
                  background: "#f8f9fa",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
                }}
              >
                <tr>
                  <th style={{ minWidth: "60px" }}>S.No.</th>
                  {columns.map((col) => (
                    <th key={col}>{formatHeader(col)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {datalogs.map((log, idx) => (
                  <tr key={log._id || idx}>
                    <td>{idx + 1}</td>
                    {columns.map((col) => {
                      let value = log[col];

                      // If it's an image path
                      if (col.toLowerCase().includes("image_path") && value) {
                        const imageUrl = value.startsWith("http")
                          ? value
                          : `https://visionemptrack.greymatterz.com/${value}`;

                        return (
                          <td key={col}>
                            <img
                              src={imageUrl}
                              alt="Event snapshot"
                              style={{
                                width: "80px",
                                height: "auto",
                                borderRadius: "4px",
                                cursor: "pointer",
                                border: "1px solid #ddd",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                transition: "transform 0.2s ease",
                              }}
                              onClick={() => setZoomImage(imageUrl)}
                              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                            />
                          </td>
                        );
                      }

                      // Format date/time
                      if (
                        col.toLowerCase().includes("time") ||
                        col.toLowerCase().includes("date")
                      ) {
                        value = formatTime(value);
                      }

                      // Format booleans
                      if (typeof value === "boolean") {
                        value = value ? "Yes" : "No";
                      }

                      return <td key={col}>{value ?? 0}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Image Zoom Modal */}
      {zoomImage && (
        <div
          onClick={() => setZoomImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
              borderRadius: "6px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
    </>
  );
}

export default EventLogsTable;
